

export const GET_CART_REQUEST  = "GET_CART_REQUEST"
export const GET_CART_SUCCESS  = "GET_CART_SUCCESS"
export const GET_CART_FAILURE  = "GET_CART_FAILURE"


export const ADD_CART_REQUEST  = "ADD_CART_REQUEST"
export const ADD_CART_SUCCESS  = "ADD_CART_SUCCESS"
export const ADD_CART_FAILURE  = "ADD_CART_FAILURE"



export const UPDATE_CART_REQUEST  = "UPDATE_CART_REQUEST"
export const UPDATE_CART_SUCCESS  = "UPDATE_CART_SUCCESS"
export const UPDATE_CART_FAILURE  = "UPDATE_CART_FAILURE"

export const REMOVE_CART_REQUEST  = "REMOVE_CART_REQUEST"
export const REMOVE_CART_SUCCESS  = "REMOVE_CART_SUCCESS"
export const REMOVE_CART_FAILURE  = "REMOVE_CART_FAILURE"